import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import { Box, Card, CardHeader, IconButton, Stack } from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import { useNavigate } from "react-router-dom";
import { postData } from "../../../api/Services";
import { ArrowBack } from "@mui/icons-material";
import { MotorVariantForm } from "./components/motorVariantForm";
import { useLoading } from "../../../components/Loading";
import { useSnackbar } from "../../../context/popup";

const AddMotorVariant = () => {

  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const { setCircleLoading } = useLoading();

  const handleAddVariant = async (variantData) => {
    setCircleLoading(true);
    const payload = {
      name: variantData?.name,
      motorCategoryId: variantData?.vehicleCategory?.value,
      motorModelId: variantData?.motorModelId,
      fuelTypeId: variantData?.fuelType?.value,
      bodyStyleId: variantData?.bodyStyle?.value,
      bodyTypeId: variantData?.bodyType?.value,
      engineCapacity: Number(variantData?.engineCapacity),
      seatCapacity: Number(variantData?.seatCapacity),
      carryingCapacity: Number(variantData?.carryingCapacity),
      iibCode: Number(variantData?.iibCode),
      wheels: Number(variantData?.wheels),
      launchYear: Number(variantData?.launchYear?.value),
      isActive: variantData?.isActive,
    };
     try {
          const reponse = await postData(
            "/reference/motor/mmv/variant",
            payload
          );
          const successResponse = reponse?.success;
          const responseMessage = reponse?.message;
          if (successResponse) {
            navigate("/motor-master/motor-MMV?tabState=variant");
            showSnackbar(responseMessage,"success");
          } else {
            showSnackbar(responseMessage,"error");
          }
        } catch (error) {
          console.error("Error Submitting",error);
          showSnackbar(error?.response?.data?.message || "Network Error","error");
        }
        finally{
          setCircleLoading(false);
        }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                <IconButton onClick={() => window.history.back()}>
                  <ArrowBack />
                </IconButton>
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Add Variant details
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    Add New Variant Details here.
                  </MaterialTypography>
                </Stack>
              </Stack>
            </Stack>
          }
        />
        <Box>
          <MotorVariantForm onsubmit={handleAddVariant} />
        </Box>
      </Card>
    </DashboardLayout>
  );
};

export default AddMotorVariant;
